import { render } from "./ListSurveys.vue?vue&type=template&id=1f551eb3"
import script from "./ListSurveys.vue?vue&type=script&lang=js"
export * from "./ListSurveys.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__